import { useMemo } from 'react';
import { useRegistrySession } from '../session/RegistrySession';
import { useTenantScope } from '../store/selectors';
import type { BadgeKey } from './managerNav';

export function useManagerBadges(): Record<BadgeKey, number> {
  const scope = useTenantScope();
  const signedIn = Boolean(useRegistrySession());
  return useMemo(
    () => ({
      // Signed in, Approvals is the live inbox, so the mock queue's count would mislead.
      approvals: signedIn ? 0 : scope.approvals.filter((item) => item.status === 'PENDING').length,
      kyc: scope.kycCases.filter((item) => item.status === 'OPEN' || item.status === 'ESCALATED')
        .length,
      payments: scope.bankLines.filter(
        (line) => line.status === 'UNMATCHED' || line.status === 'SUGGESTED',
      ).length,
      applications: scope.applications.filter((item) =>
        ['SUBMITTED', 'KYC_REVIEW', 'AWAITING_FUNDS'].includes(item.status),
      ).length,
      changes: scope.changeRequests.filter(
        (item) => item.status === 'SUBMITTED' || item.status === 'VERIFYING',
      ).length,
    }),
    [scope, signedIn],
  );
}
